import * as React from "react";
import Container from "@mui/material/Container";
import { UserDetails } from "./UserDetails";
import LabelImportantOutlinedIcon from "@mui/icons-material/LabelImportantOutlined";
import { GenericMessage } from "../components/util/GenericMessage";

const Header = () => {
  /********Website header noftifaction mgs*********/
  const headMessage = {
    display: false, //needs to be true to show downtime message
    message:
      "Briefly unavailable for scheduled maintenance please check back in a minute",
  };

  return (
    <>
      <GenericMessage data={headMessage} />
      <Container maxWidth={false} className="header">
        <div className="head-warp">
          <div className="logo"></div>
          <span className="app-heading">
            <LabelImportantOutlinedIcon
              fontSize="medium"
              sx={{ margin: "0px 8px", fontSize: "1.8rem" }}
            />
            Nuveen Value Hub
          </span>
        </div>
        <UserDetails />
      </Container>
    </>
  );
};

export default Header;
